export default __webpack_public_path__ + "img/a76ecab27147cf4039084d37d1f473cc.mp4";